import React, { useState } from "react";
import ModalChuyenNhapRutQuy from "../ModalChuyenNhapRutQuy";

const BtnRutQuy = ({ onReload, RoleQuyTienMatDuyetQuy }) => {
    const [show, setShow] = useState(false);

    return (
        <>
            <a type="button" onClick={() => setShow(true)} style={{fontSize: 15}} className="btn">
                <span>
                    <img
                        src="/app-assets/images/icon-rut-quy.png"
                        style={{  marginRight: '6px' }}
                        alt="Rút quỹ"
                    />
                    Rút quỹ
                </span>
            </a>
            
            {show && (
                <ModalChuyenNhapRutQuy
                    show={show}
                    onHide={() => setShow(false)}
                    mode={{ type: 52 }} // Type 52: Rút quỹ
                    onSuccess={() => { setShow(false); if (onReload) onReload(); }}
                    RoleQuyTienMatDuyetQuy={RoleQuyTienMatDuyetQuy}
                />
            )}
        </>
    );
};
export default BtnRutQuy;